import { Show, SimpleShowLayout, TopToolbar } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import DocumentGenerationSection from "./DocumentGenerationSection";
import DocumentsSection from "./DocumentsSection";
import EducationSection from "./EducationSection";
import InternshipsSection from "./InternshipsSection";
import MobilitySection from "./MobilitySection";
import PersonalDataSection from "./PersonalDataSection";

const ShowIncomingIntershipStudents = () => (
  <Show
    title="Детайли на пристигащ на стаж"
    actions={
      <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
        <BackButtonToolbar />
      </TopToolbar>
    }
  >
    <SimpleShowLayout>
      <PersonalDataSection />
      <EducationSection />
      <MobilitySection />
      <InternshipsSection />
      <DocumentsSection />
      <DocumentGenerationSection />
    </SimpleShowLayout>
  </Show>
);

export default ShowIncomingIntershipStudents;
